const colorOptionNameMap: Record<string, string> = {
  "PRD-E7TIEWKQY": "Substrate Color", //Personalized Travel Mug
  "PRD-HONALU7W1": "Substrate Color", //Kids' Water Bottle
  "PRD-OPTIMWT6J": "Colour", //EU Personalized Mugs
  "PRD-NSSLDGRSC": "Substrate Color", //Consumer Speckled Ceramic Mug
  "PRD-QML6SSIJD": "Substrate Color", //40oz Polar Camel Travel Mug with Straw
  "PRD-D9C5QUD2X": "Substrate Color", //20oz Polar Camel Tumbler
  "PRD-9TQAO366C": "Substrate Color", //20oz Polar Camel Travel Mug
  "PRD-ITPYQQB22": "Substrate Color", //20oz RTIC Water Bottle
  // "PRD-VBEUEYPR": "Substrate Color", //ANZS Mugs to be launched
  "PRD-0BKUQJYW": "Handle Color", // NA Custom Mug
};

export const getColorOptionName = (productKey: string): string | undefined => {
  return colorOptionNameMap[productKey];
};
